export default "__VITE_ASSET__C$Gaognz__"